import { localStorageService } from "../../../../services/LocalStorageService";

export const shouldShowTutorial = (tutorialKey: string, userId: string): boolean => !localStorageService.getTutorialDismissed(tutorialKey, userId);
